const machine_txt = {
    type: "VA-1900",
    name: "HIGH SPEED COMPUTERIZED BAR-TACKINGSEWING MACHINE",
    description: [
        "Software and hardware perfectly integrated.Sensory automatic feedback, precise positioning, speed out of control avoidance, quick response, high efficiency.",
        "Save power consumption, lower noise, lower vibration,economy.",
        "Machine head and control box combined together, easily for install, store and transport.",
        "The totally enclosed connecting bar,lubrication design to the eccentric wheel and gear,extend the machine life and decrease the noise.",
        "Common Specifications",
        "550W input power, easy to punture materials.",
        "Full closed-loop control system, fast response, high efficiency and no out of step.",
        "Max speed up to 3300rpm.",
        "Large sewing area, variety kinds of patterns.",
        "Fully sealed lubrication design of main mechanism, lower sound and long service life.",
        "Motor control presser foot lifting and thread trimming, fast response, stable action and lower sound.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/10/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/10/machine_other/1.png",
        "/assets/machine/10/machine_other/2.png",
    ]
}
export default {machine_txt}